import React from "react"
import { NavLink } from "react-router-dom"
import moment from "moment"

// UI components
import Badge from "../ui/badge/badge"

// Booking table row for the suppliers stats page
export default function Booking(props) {
	// Deconstruct the details from the props - all data is now pre-calculated
	const { id, details, sorting, client, agent, supplierDetails, supplierCost, supplierType } = props

	// Generate a string to represent the check_in date from the timestamps
	const checkInDate = moment(details.check_in?.seconds, "X").format("MMM D[,] YYYY")
	const bookedDate = moment(details.booked?.seconds, "X").format("MMM D[,] YYYY")

	return (
		<tr>
			<td>
				{(supplierCost || 0).toLocaleString() === "0" && <div className="no-values-tag" />}

				<NavLink to={`booking/${id}`}>{details.reference}</NavLink>
			</td>
			<td>
				{agent?.first_name && `${agent.first_name} ${agent.last_name}`}
				{!agent?.first_name && <small className="no-value">No name set</small>}
			</td>
			{sorting === "booked_date" && <td>{bookedDate}</td>}
			{sorting === "travel_date" && <td>{checkInDate}</td>}
			<td>
				{client?.first_name && `${client.first_name} ${client.last_name}`}
				{!client?.first_name && <small className="no-value">No name set</small>}
			</td>
			<td>{details.golfers}</td>
			<td>{details.non_golfers}</td>
			<td>
				{details.confirmed && (
					<Badge
						label="Yes"
						type="POSITIVE"
					/>
				)}

				{!details.confirmed && (
					<Badge
						label="No"
						type="NEGATIVE"
					/>
				)}
			</td>
			<td>
				{supplierType} {supplierDetails?.name}
			</td>
			<td>£{(supplierCost || 0).toLocaleString()}</td>
			<td>
				{details.resorts_paid && (
					<Badge
						label="Yes"
						type="POSITIVE"
					/>
				)}

				{!details.resorts_paid && (
					<Badge
						label="No"
						type="NEGATIVE"
					/>
				)}
			</td>
			<td className="is-button">
				<NavLink to={`booking/${id}`}>View booking</NavLink>
			</td>
		</tr>
	)
}
